export default "__VITE_ASSET__eb28b0e5__"